import React from 'react'
import {
  compose,
  withProps,
  nest,
  lifecycle,
} from 'recompose'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import get from 'lodash/get'
import { Combobox as Select } from 'react-widgets'

import { withDebounce } from '@infotech/base-components'
import inputMessages from './inputMessages'
import PickerWrapper from './components/PickerWrapper'
import { IssueLinkInfoblock } from './components/IssueLinkInfoblock'


const LinkedIssueSelect = compose(
  withProps(({ issueLinkSystemType }) => ({
    itemComponent: ({ item }) => (
      <IssueLinkInfoblock
        issueLinkSystemType={issueLinkSystemType}
        issueLink={item}
      />
    ),
    messages: inputMessages,
  })),
  withProps(({
    input,
    autocompleteKey,
  }) => ({
    value: autocompleteKey || input.value,
  })),
  connect((state, { meta: { form } }) => ({
    esuzNumber: get(getFormValues(form)(state), `esuzNumber`),
  })),
  lifecycle({
    componentDidMount() {
      const {
        onChange,
        esuzNumber,
      } = this.props
      esuzNumber && onChange(esuzNumber)
    },
  }),
  withProps({
    wait: 1000,
  }),
  withDebounce,
)(Select)

export default nest(PickerWrapper, LinkedIssueSelect)
